import { userProfile as base } from './base';
import { userProfile as AT } from './AT';
import { userProfile as SK } from './SK';

export const featureConfigMap = {
    base,
    AT,
    SK,
};
